import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import HeroImage from "../../src/assets/image/png/image1.png"; 
import icon from "../assets/image/svg/icon.svg";

const ServicePlace = () => {
  return (
    <section id="service" className="pt-5">
      <div className="container">
        <div className="row flex-column-reverse flex-lg-row justify-content-between align-items-center">
          
               <div className="col-lg-5 text-center position-relative mt-5 mt-md-0">
            <img
              src={HeroImage}
              alt="App screen 1"
              className="img-fluid position-relative"
              style={{ zIndex: 2 }}
            />
          </div>
          {/* Left Content */}
          <div className="col-lg-5 pb-md-5 mt-5 text-center text-lg-start">
            <img src={icon} alt="icon" width={51} height={51} />
            <p className="text-uppercase mt-3 clrTheme fw-bold fs_24 mb-2">
              All Your Services in One Place
            </p>
            <p className="text-muted mb-4">
              Vasta keeps your bookings, payments, and service history organized making it easy to track and manage everything effortlessly.
            </p>
            <button
              style={{ backgroundColor: "#044434" }}
              className="px-5 border-0 py-2 rounded-3 text-white"
            >
              Get Started
            </button>
          </div>

          {/* Right Image */}
     
        </div>
      </div>
    </section>
  );
};

export default ServicePlace;
